import React, { useEffect, useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

Dialog.propTypes = {
    children: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    classes: PropTypes.string
};

export default function Dialog({ children, onClose, label, id, classes }) {
    return (
        <div
            className={classnames("modal show")}
            aid={id}
            arial-model="true"
            style={{ display: "block", backgroundColor: "rgba(0,0,0, 0.3)" }}
        >
            <div
                className={classnames("modal-dialog modal-dialog-centered", {
                    [classes]: classes
                })}
            >
                <div className="modal-content" style={{ borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
                    <div className="modal-header" style={{ 
                        background: 'linear-gradient(135deg, #34bfa3 0%, #259d85 100%)',
                        color: '#ffffff',
                        borderBottom: 'none',
                        padding: '20px 25px',
                        borderRadius: '8px 8px 0 0'
                    }}>
                        <h4 className="modal-title" style={{ 
                            margin: 0,
                            fontWeight: '700',
                            fontSize: '20px',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase'
                        }}>
                            {label}
                        </h4>
                    </div>
                    <div className="modal-body" style={{ padding: '25px' }}>{children}</div>
                </div>
            </div>
        </div>
    );
}
